export class Disclaimer {
  constructor(public content: string) {}
}
